import useFeatureFlags from 'hooks/feature-flags/useFeatureFlags'
import useIsLegalEntityRootOrg from 'hooks/utils/useIsLegalEntityRootOrg'

const useIsVoucherEnabled = () => {
  const { isVoucherWorkflowEnabled } = useFeatureFlags()
  const { isLegalEntityRootOrg, isLoading } = useIsLegalEntityRootOrg()

  // Default to false while loading to prevent flash of voucher UI for parent orgs
  const isVoucherEnabled = !isLoading && isVoucherWorkflowEnabled && !isLegalEntityRootOrg

  return { isVoucherEnabled, isLoading }
}

export default useIsVoucherEnabled
